var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStats = function SvgStats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M5.832 14.166v-3.333M10 14.166V5.833M14.168 14.167v-5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.082 10c0-3.732 0-5.598 1.16-6.758C4.4 2.083 6.266 2.083 9.998 2.083s5.598 0 6.757 1.16c1.16 1.159 1.16 3.025 1.16 6.757s0 5.598-1.16 6.757c-1.16 1.16-3.025 1.16-6.757 1.16s-5.598 0-6.758-1.16C2.082 15.597 2.082 13.732 2.082 10Z"
  })));
};
export default SvgStats;